import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { STORAGE_REDIRECT } from './constants';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SpotifyService {
  spotifyCredentials: any = {}

  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router) {
    const params = route.queryParams.subscribe(params => {
      if (params.code) {
        const redirect = localStorage.getItem(STORAGE_REDIRECT)
        this.saveCode(params.code, redirect)
          .subscribe(x => {
            // Check for redirect
            const redirect = localStorage.getItem(STORAGE_REDIRECT)
            if (redirect && redirect != 'undefined') {
              localStorage.removeItem(STORAGE_REDIRECT)
              this.router.navigate(redirect.includes('presave') ? redirect.split('/').concat(['success']) : redirect.split('/'), { queryParamsHandling: 'preserve' })
            }
          })
      }
    })
  }

  saveCode(code, url_alias): Observable<any> {
    return this.http.post<any>(`/api/spotify/code`, { code, url_alias })
  }

  preSave(albumId): Observable<any> {
    return this.http.post<any[]>(`/api/spotify/presave`, { spotifyCredentials: this.spotifyCredentials, albumId })
  }

  getAlbum(url_alias): Observable<any> {
    return this.http.get<any>(`/api/spotify/album/${url_alias}`)
  }

  saveAlbum(albumId): Observable<any> {
    return this.http.post<any>(`/api/spotify/save`, { spotifyCredentials: this.spotifyCredentials, albumId })
  }

  getArtistByURI(uri) {
    return this.http.get<any>(`/api/spotify/uri?uri=${encodeURIComponent(uri)}`)
  }

  lookupByURI(uri) {
    return this.http.get<any>(`/api/spotify/getArtistByUri?uri=${encodeURIComponent(uri)}`)
  }
}
